<template>
  <div>
    <!-- SELECT CUSTOMER DIALOG -->
    <el-dialog v-if="visible" :close-on-click-modal="false" title="Select Customer" :model-value="visible"
      @update:modelValue="(val) => { if (!val) modal.closeCustomer() }" width="50%" class="customer-select-dialog">
      <el-input v-model="searchQuery" placeholder="Search customer name" clearable @input="handleSearchInput"
        style="margin-bottom: 12px" />
      <el-button size="small" type="primary" style="margin-bottom: 10px" @click="handleCustomerAdd">Add New</el-button>
      <el-table :data="list" stripe v-loading="loading" @row-click="handleSelect"
        header-cell-class-name="my-header">
        <el-table-column prop="name" label="Customer Name" />
      </el-table>
      <PaginationBar :query="query" :total="total" @change="getList" />
    </el-dialog>

    <!-- ADD CUSTOMER DIALOG -->
    <CustomerFormDialog v-model:visible="addVisible" :row="null" @saved="handleCustomerSaved" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { debounce } from 'lodash'
import { fetchList as fetchCustomerList } from '@/api/customer'
import { useList } from '@/composables/useList'
import { useModalStore } from '@/stores/modal'
import { defaultCustomerListQuery as defaultListQuery } from './defaults'
import CustomerFormDialog from '@/views/sms/customer/components/CustomerFormDialog.vue'
import PaginationBar from '@/components/PaginationBar.vue'

const modal = useModalStore()

const visible = ref(false)
const addVisible = ref(false)
const searchQuery = ref('')

const { list, loading, total, query, getList } = useList(fetchCustomerList, defaultListQuery)

watch(() => modal.customer.visible, async (val) => {
  if (val) {
    searchQuery.value = ''
    query.keyword = null
    query.pageNum = 1
    visible.value = true
    await getList()
  } else {
    visible.value = false
  }
}, { immediate: true })

const handleSearchInput = debounce(() => {
  query.keyword = searchQuery.value || null
  query.pageNum = 1
  getList()
}, 300)

function handleSelect(row) {
  modal.resolveCustomer(row)
}

function handleCustomerAdd() {
  addVisible.value = true
}

async function handleCustomerSaved() {
  await getList()
}
</script>

<style scoped>
.my-header {
  font-weight: bold;
}
</style>
